<!-- Slick slider Client logo list -->
<div class="container">
	<!-- <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (afterChange)="afterChange($event)">
	    <div ngxSlickItem *ngFor="let slide of logoList" class="slide">
	    	<a href="javascript:void(0);">
	          <img  height="100"  src="{{ slide?.logo_path }}" alt="client logo" />
	        </a>
	    </div>
	</ngx-slick-carousel> -->
</div><!-- container closed -->

